// Affiliate Links
const DumbellLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FEveryday-Essentials-Contoured-Handle-Cast-Iron-Adjustable-Dumbbell-Weight-Set-20-lbs-Pair%2F212738014%3Fathbdg%3DL1700'
const DumbellLightLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FCAP-Barbell-Neoprene-Dumbbell-Single-2-lbs%2F436519701'
const AgilityLadderLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FAthletic-Works-Footwork-Speed-Agility-Ladder%2F121241482'
const ResistanceBandsLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FFit-Pride-Pioneer-Rona-Resistance-Bands-Exercise-Bands-Set-5-Workout-Ankle-Leg-Stretching-Physical-Therapy-Yoga-Home-Fitness-Carry-Bag%2F652242259%3Fathbdg%3DL1600'
const JumpRopeLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FEverlast-Deluxe-Speed-Jump-Rope-9-Ft-Black%2F836767839'
const YogaMatLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fgoto.walmart.com%2Fc%2F2775629%2F565706%2F9383%3Fveh%3Daff%26sourceid%3Dimp_000011112222333344%26u%3Dhttps%253A%252F%252Fwww.walmart.com%252Fip%252FEveryday-Essentials-All-Purpose-1-2-In-High-Density-Foam-Exercise-Yoga-Mat-Anti-Tear-with-Carrying-Strap-Blue%252F275846958%253Fathbdg%253DL1600'
const ChinUpBarLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FSGODDE-Pull-Up-Bar-Multifunctional-Chin-Up-Upper-Body-Workout-Bar-Home-Gym-Exercise-Equipment-Strength-Training%2F589069013%3Fathbdg%3DL1700'
const WorkoutStepsLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FStamina-3-Level-Aerobic-Step-Deck-Adjustable-to-4-6-8%2F761252824%3Fathbdg%3DL1600'
const StabilityBallLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FSPRI-Weighted-Stability-Exercise-Ball-65CM-Grey%2F888781400%3Fathbdg%3DL1600'
const YogaBlockLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FNode-Fitness-Premium-Yoga-Block-Set-of-2-3-Inch-Thick-EVA-Foam-Brick-Purple%2F513183734'
const StrengthSlidesLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2F2-Pieces-Sport-Exercise-Sliders-for-Fitness-Workout-Double-Sided-Gilder-Strength-Slides-Discs-Core-Sliders-Work-Smoothly%2F765194256%3Fathbdg%3DL1400'
const SandBagLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2FXPRT-Fitness-Black-Workout-Sandbag-Size-S%2F841128856'
const AgilityMarkersLink = 'https://goto.walmart.com/c/2775629/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fip%2F30-36Pcs-Spot-Markers-Floor-Spots-Circles-Sitting-Dots-for-Classroom-Preschool-and-Kindergarten%2F917741903%3Fwmlspartner%3Dwlpa%26selectedSellerId%3D16214%26%26adid%3D22222222227330047581%26wl0%3D%26wl1%3Dg%26wl2%3Dc%26wl3%3D412874001563%26wl4%3Daud-1308651922216%3Apla-867034970372%26wl5%3D9005250%26wl6%3D%26wl7%3D%26wl8%3D%26wl9%3Dpla%26wl10%3D120798572%26wl11%3Donline%26wl12%3D917741903%26veh%3Dsem%26gclid%3DCjwKCAiAqIKNBhAIEiwAu_ZLDvM-jkCWSJ8s7aIFfy0YdW3cwhC8YIF2oM-F9f_n0o0OqxFDdmYyuRoCZg0QAvD_BwE%26gclsrc%3Daw.ds'

export default [
  {
    id: 1,
    name: 'Insanity',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_INSANITY_PRICE_ID}`, // Strip Checkout price id
    imageURL: require('../images/workoutCovers/Insanity.png'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FInsanity.png?alt=media&token=22127ce5-8769-4130-aa00-3b3d71e4d008',
    includes: {
      a: '63 Days Program',
      b: '6 Workouts Per Week',
      c: '14 Workout Videos'
    },
    equipments: {
      a: 'No Equipment Required'
    }
  },
  {
    id: 2,
    name: 'Insanity Max 30',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_MAX30_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/InsanityMax30.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FInsanityMax30.jpg?alt=media&token=318fea6c-8914-4c10-99db-43082eea6aa2',
    includes: {
      a: '55 Days Program',
      b: '6 Workouts Per Week',
      c: '15 Workout Videos'
    },
    equipments: {
      a: 'No Equipment Required'
    }
  },
  {
    id: 3,
    name: 'Insanity Asylum Vol 1',
    category: 'Cardio',
    price: 4.99,
    price_id: `${process.env.VUE_APP_ASYLUM_V1_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/AsylumVol1.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FAsylumVol1.jpeg?alt=media&token=69442e77-8bc8-4e48-a459-aeed1b8080c2',
    includes: {
      a: '30 Days Program',
      b: '6 Workouts Per Week',
      c: '8 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Agility ladder', AgilityLadderLink],
      b: ['Resistance Bands', ResistanceBandsLink],
      c: ['Jump Rope', JumpRopeLink],
      d: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 4,
    name: 'Insanity Asylum Vol 2',
    category: 'Cardio',
    price: 4.99,
    price_id: `${process.env.VUE_APP_ASYLUM_V2_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/AsylumVol2.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FAsylumVol2.jpg?alt=media&token=12b278e0-7539-4951-b6ac-be9625666472',
    includes: {
      a: '28 Days Program',
      b: '6 Workouts Per Week',
      c: '9 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Agility ladder', AgilityLadderLink],
      b: ['Resistance Bands', ResistanceBandsLink],
      c: ['Jump Rope', JumpRopeLink],
      d: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 5,
    name: 'FOCUS T25',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_T25_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/T25.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FT25.jpg?alt=media&token=7832ed3a-18b2-44f7-a16e-c2f60e4b90b2',
    includes: {
      a: '98 Days Program',
      b: '6 Workouts Per Week',
      c: '16 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Bands', ResistanceBandsLink],
      b: ['Chin-Up Bar', ChinUpBarLink],
      c: ['Dumbbells', DumbellLink],
      d: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 6,
    name: 'Transform 20',
    category: 'Cardio',
    price: 14.99,
    price_id: `${process.env.VUE_APP_T20_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/Transform20.png'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FTransform20.png?alt=media&token=743a267e-0c69-4f3c-b803-c38c07714762',
    includes: {
      a: '42 Days Program',
      b: '6 Workouts Per Week',
      c: '36 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Workout Step', WorkoutStepsLink],
      b: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 7,
    name: 'P90X',
    category: 'Muscle',
    price: 9.99,
    price_id: `${process.env.VUE_APP_P90X_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/P90x.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FP90X.jpg?alt=media&token=6c330cba-040d-47d0-aa6d-c2baaaf86c41',
    includes: {
      a: '91 Days Program',
      b: '7 Workouts Per Week',
      c: '13 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Bands', ResistanceBandsLink],
      b: ['Yoga Mat', YogaMatLink],
      c: ['Dumbbells', DumbellLink],
      d: ['Chin-Up Bar', ChinUpBarLink]
    }
  },
  {
    id: 8,
    name: 'P90X2',
    category: 'Muscle',
    price: 9.99,
    price_id: `${process.env.VUE_APP_P90X2_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/P90x2.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FP90X2.jpg?alt=media&token=272fd16d-26b6-4fb7-8eb9-bb48fceb3d3d',
    includes: {
      a: '105 Days Program',
      b: '6 Workouts Per Week',
      c: '15 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Bands', ResistanceBandsLink],
      b: ['Yoga Mat', YogaMatLink],
      c: ['Dumbbells', DumbellLink],
      d: ['Chin-Up Bar', ChinUpBarLink],
      e: ['Stability Ball (optional)', StabilityBallLink],
      f: ['Yoga Blocks (optional)', YogaBlockLink]
    }
  },
  {
    id: 9,
    name: 'P90X3',
    price: 9.99,
    category: 'Muscle',
    price_id: `${process.env.VUE_APP_P90X3_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/P90x3.png'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FP90X3.png?alt=media&token=240b952e-95fd-4517-b812-94dfbfeb6b4d',
    includes: {
      a: '91 Days Program',
      b: '6 Workouts Per Week',
      c: '18 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Bands', ResistanceBandsLink],
      b: ['Yoga Mat', YogaMatLink],
      c: ['Dumbbells', DumbellLink],
      d: ['Chin-Up Bar', ChinUpBarLink],
      e: ['Stability Ball (optional)', StabilityBallLink],
      f: ['Yoga Blocks (optional)', YogaBlockLink]
    }
  },
  {
    id: 10,
    name: 'CORE DE FORCE',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_CDF_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/CoreDeForce.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FCDF.jpg?alt=media&token=fb635309-6502-4726-a0fd-dffd93d3defd',
    includes: {
      a: '30 Days Program',
      b: '7 Workouts Per Week',
      c: '15 Workout Videos'
    },
    equipments: {
      a: 'No Equipment Required'
    }
  },
  {
    id: 11,
    name: '10 Rounds',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_10ROUNDS_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/10Rounds.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2F10Rounds.jpg?alt=media&token=b42cdc26-97b6-495a-85b0-d4bf6333cea4',
    includes: {
      a: '40 Days Program',
      b: '5 Workouts Per Week',
      c: '32 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Dumbells', DumbellLink],
      b: ['Resistance Bands', ResistanceBandsLink]
    }
  },
  {
    id: 12,
    name: '3 Week Yoga Retreat',
    category: 'Yoga',
    price: 4.99,
    price_id: `${process.env.VUE_APP_3WYOGARETREAT_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/3WYogaRetreat.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2F3WYogaRetreat.jpeg?alt=media&token=4ff3b141-3cf4-4afa-b505-c527c81dac83',
    includes: {
      a: '21 Days Program',
      b: '7 Workouts Per Week',
      c: '21 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 13,
    name: 'Yoga Warrior 365',
    category: 'Yoga',
    price: 9.99,
    price_id: `${process.env.VUE_APP_YOGAWARRIOR365_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/YogaWarrior365.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FYogaWarrior365.jpeg?alt=media&token=826d7c86-d5ee-4855-8849-0f40c075f3a1',
    includes: {
      a: '89 Days Program',
      b: '6 Workouts Per Week',
      c: '14 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 14,
    name: 'Tap Out XT',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_TapOutXT_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/TapOutXT.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FTapOutXT.jpg?alt=media&token=caadc51b-50e3-4bc1-8d2c-d3af79e6424a',
    includes: {
      a: '84 Days Program',
      b: '6 Workouts Per Week',
      c: '12 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Bands', ResistanceBandsLink],
      b: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 15,
    name: 'Turbo Fire',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_TurboFire_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/TurboFire.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FTurboFire.jpeg?alt=media&token=c88feb0e-a8e8-4c67-8511-b14a35576417',
    includes: {
      a: '140 Days Program',
      b: '7 Workouts Per Week',
      c: '17 Workout Videos'
    },
    equipments: {
      a: 'No Equipment Required'
    }
  },
  {
    id: 16,
    name: '6 Weeks of The Work',
    category: 'Muscle',
    price: 14.99,
    price_id: `${process.env.VUE_APP_6WeekOfTheWork_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/6WeeksOfTheWork.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2F6WeeksOfTheWork.jpeg?alt=media&token=0729070d-a4d5-44d1-9b59-c233c58446c9',
    includes: {
      a: '42 Days Program',
      b: '6 Workouts Per Week',
      c: '36 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Dumbbells', DumbellLink],
      b: ['Resistance Bands', ResistanceBandsLink],
      c: ['Strength Slides', StrengthSlidesLink]
    }
  },
  {
    id: 17,
    name: '5 Day Yoga Challenge',
    category: 'Yoga',
    price: 4.99,
    price_id: `${process.env.VUE_APP_5DayYogaChallenge_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/5DayYogaChallenge.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2F5DayYogaChallenge.jpeg?alt=media&token=7f029f74-dc7d-42ce-98d5-a03ba2638ba0',
    includes: {
      a: '5 Days Program',
      b: '1 Week Workouts',
      c: '6 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 18,
    name: '22 Minute Hard Corps',
    category: 'Muscle',
    price: 9.99,
    price_id: `${process.env.VUE_APP_22MinuteHardCorps_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/22MinuteHardCorps.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2F22MinuteHardCorps.jpg?alt=media&token=9f3d3a0e-8850-4601-93c5-b13a0a4c9efd',
    includes: {
      a: '63 Days Program',
      b: '6 Workouts Per Week',
      c: '12 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Sandbag', SandBagLink],
      b: ['Resistance Bands', ResistanceBandsLink],
      c: ['Chin-Up Bar', ChinUpBarLink],
      d: ['Dumbbells', DumbellLink],
      e: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 19,
    name: 'A Little Obsessed',
    category: 'Cardio',
    price: 4.99,
    price_id: `${process.env.VUE_APP_ALittleObsesssed_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/ALittleObsessed.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FALittleObsessed.jpeg?alt=media&token=08b69924-9e5e-4abb-80b8-3418fb2f955d',
    includes: {
      a: '5 Days Program',
      b: '1 Week Workouts',
      c: '5 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Bands', ResistanceBandsLink],
      b: ['Dumbbells (Light Weight)', DumbellLightLink],
      c: ['Strength Slides', StrengthSlidesLink],
      d: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 20,
    name: 'Country Heat',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_CountryHeat_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/CountryHeat.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FCountryHeat.jpg?alt=media&token=afc993f2-f0f2-48d1-bd06-624d2512125c',
    includes: {
      a: '30 Days Program',
      b: '6 Workouts Per Week',
      c: '7 Workout Videos'
    },
    equipments: {
      a: 'No Equipment Required'
    }
  },
  {
    id: 21,
    name: 'CIZE',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_Cize_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/Cize.png'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FCize.png?alt=media&token=2d5e0e8f-69c5-459f-899f-8026c16833f0',
    includes: {
      a: '28 Days Program',
      b: '6 Workouts Per Week',
      c: '7 Workout Videos'
    },
    equipments: {
      a: 'No Equipment Required'
    }
  },
  {
    id: 22,
    name: 'A Week of Hard Labor',
    category: 'Muscle',
    price: 4.99,
    price_id: `${process.env.VUE_APP_AWeekOfHardLabor_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/AWeekOfHardLabor.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FAWeekOfHardLabor.jpg?alt=media&token=8ae311ab-6f5d-473a-84d9-2ef2ed2dfb50',
    includes: {
      a: '5 Days Program',
      b: '1 Week Workouts',
      c: '5 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Bands', ResistanceBandsLink],
      b: ['Dumbbells', DumbellLink],
      c: ['Chin-Up Bar', ChinUpBarLink],
      d: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 23,
    name: 'Clean Week',
    category: 'Cardio',
    price: 4.99,
    price_id: `${process.env.VUE_APP_CleanWeek_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/CleanWeek.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FCleanWeek.jpeg?alt=media&token=486f1156-5f64-4c2b-a13b-7a0080e6c42d',
    includes: {
      a: '7 Days Program',
      b: '1 Week Workouts',
      c: '4 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Dumbbells (Light Weight)', DumbellLightLink],
      b: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 24,
    name: 'APY60',
    category: 'Yoga',
    price: 14.99,
    price_id: `${process.env.VUE_APP_APY60_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/APY60.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FAPY60.jpg?alt=media&token=340b9eef-2df5-43ab-af93-282ae209e9c0',
    includes: {
      a: '60 Days Program',
      b: '6 Workouts Per Week ',
      c: '80 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 25,
    name: 'Jillian Michaels Body Shred',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_JillianMichaelsBodyShred_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/JillianMichaelsBodyShred.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FJillianMichaelsBodyShred.jpeg?alt=media&token=06db704b-f4c4-4c57-9ab9-260b1a591351',
    includes: {
      a: '56 Days Program',
      b: '6 Workouts Per Week ',
      c: '10 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink],
      b: ['Dumbbells (Light Weight)', DumbellLightLink]
    }
  },
  {
    id: 26,
    name: 'LIIFT 4',
    category: 'Muscle',
    price: 14.99,
    price_id: `${process.env.VUE_APP_Liift4_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/Liift4.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FLiift4.jpeg?alt=media&token=a05aa131-8651-44f1-8c66-26590a842928',
    includes: {
      a: '56 Days Program',
      b: '4 Workouts Per Week ',
      c: '33 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink],
      b: ['Dumbbells', DumbellLink]
    }
  },
  {
    id: 27,
    name: 'Morning Meltdown 100',
    category: 'Cardio',
    price: 14.99,
    price_id: `${process.env.VUE_APP_MorningMeltdown100_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/MorningMeltdown100.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FMorningMeltdown100.jpeg?alt=media&token=aa4dfa40-3cc8-42a0-b842-e3415f8e8462',
    includes: {
      a: '100 Days Program',
      b: '6 Workouts Per Week ',
      c: '100 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink],
      b: ['Dumbbells (Light Weight)', DumbellLightLink]
    }
  },
  {
    id: 28,
    name: 'Total Transformation Training',
    category: 'Cardio',
    price: 9.99,
    price_id: `${process.env.VUE_APP_TotalTransformationTraining_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/TotalTransformationTraining.png'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FTotalTransformationTraining.png?alt=media&token=5a63deda-2dbe-40e2-b440-023fb1f19636',
    includes: {
      a: '28 Days Program',
      b: '6 Workouts Per Week ',
      c: '7 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink],
      b: ['Dumbbells (Light Weight)', DumbellLightLink]
    }
  },
  {
    id: 29,
    name: 'RIPT 90',
    category: 'Muscle',
    price: 9.99,
    price_id: `${process.env.VUE_APP_Ript90_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/Ript90.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FRipt90.jpg?alt=media&token=36f393a0-c6b9-46b6-8462-3e0b9a16dc81',
    includes: {
      a: '90 Days Program',
      b: '7 Workouts Per Week ',
      c: '14 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Dumbbells', DumbellLink]
    }
  },
  {
    id: 30,
    name: 'The Ultimate Yogi',
    category: 'Yoga',
    price: 9.99,
    price_id: `${process.env.VUE_APP_UltimateYogi_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/UltimateYogi.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FUltimateYogi.jpeg?alt=media&token=2db65b3c-e835-451e-9379-848e74a28ee4',
    includes: {
      a: '108 Days Program',
      b: '7 Workouts Per Week ',
      c: '13 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 31,
    name: 'Shift Shop',
    category: 'Muscle',
    price: 9.99,
    price_id: `${process.env.VUE_APP_ShiftShop_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/ShiftShop.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FShiftShop.jpeg?alt=media&token=6f596a94-49bd-4067-ae3a-151344d89ae8',
    includes: {
      a: '42 Days Program',
      b: '7 Workouts Per Week ',
      c: '11 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Agility Markers', AgilityMarkersLink],
      b: ['Dumbbells', DumbellLink],
      c: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 32,
    name: "The Master's Hammer And Chisel",
    category: 'Muscle',
    price: 9.99,
    price_id: `${process.env.VUE_APP_TheMastersHammerAndChisel_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/TheMastersHammerAndChisel.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FShiftShop.jpeg?alt=media&token=6f596a94-49bd-4067-ae3a-151344d89ae8',
    includes: {
      a: '56 Days Program',
      b: '7 Workouts Per Week ',
      c: '19 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Chin-Up Bar', ChinUpBarLink],
      b: ['Dumbbells', DumbellLink],
      c: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 33,
    name: '21 Day Fix Ultimate',
    category: 'Carido',
    price: 4.99,
    price_id: `${process.env.VUE_APP_21DayFixUltimate_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/21DayFixUltimate.jpg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2F21DayFixUltimate.jpg?alt=media&token=877f4921-f14e-4af9-b13c-d49cda62de59',
    includes: {
      a: '56 Days Program',
      b: '7 Workouts Per Week ',
      c: '19 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Band', ResistanceBandsLink],
      b: ['Dumbbells (Light Weight)', DumbellLightLink],
      c: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 34,
    name: '21 Day Fix Extreme',
    category: 'Carido',
    price: 4.99,
    price_id: `${process.env.VUE_APP_21DayFixExtreme_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/21DayFixExtreme.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2F21DayFixExtreme.jpeg?alt=media&token=52a0cf59-e8d9-472e-a9d7-46766f037354',
    includes: {
      a: '56 Days Program',
      b: '7 Workouts Per Week ',
      c: '19 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Resistance Band', ResistanceBandsLink],
      b: ['Dumbbells (Light Weight)', DumbellLightLink],
      c: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 35,
    name: 'PiYo',
    category: 'Carido',
    price: 9.99,
    price_id: `${process.env.VUE_APP_PiYo_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/PiYo.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FPiYo.jpeg?alt=media&token=6d62db80-3063-44ef-82aa-48181a410fda',
    includes: {
      a: '56 Days Program',
      b: '6 Workouts Per Week ',
      c: '10 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Yoga Mat', YogaMatLink]
    }
  },
  {
    id: 36,
    name: 'ChaLean',
    category: 'Carido',
    price: 9.99,
    price_id: `${process.env.VUE_APP_PiYo_PRICE_ID}`,
    imageURL: require('../images/workoutCovers/ChaLean.jpeg'),
    strogeURL: 'https://firebasestorage.googleapis.com/v0/b/workoutstracker.appspot.com/o/WorkoutCovers%2FChaLean.jpeg?alt=media&token=45fac643-c639-4b38-9a7a-b5c6fbf7333a',
    includes: {
      a: '84 Days Program',
      b: '5 Workouts Per Week ',
      c: '14 Workout Videos'
    },
    equipments: {
      a: 'Equipment Required'
    },
    required: {
      a: ['Dumbbells (Light Weight)', DumbellLightLink],
      b: ['Yoga Mat', YogaMatLink]
    }
  }
]
